/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Outcome of a single workflow-run step (one YAML action). Every value except
 * @see {@link Synqo.Cloud.AgenticOrchestrator.Model.Api.EnumWorkflowStepOutcome.Running} is terminal.
 */
export enum EnumWorkflowStepOutcome {
    /**
     * The step ran to completion successfully.
     */
    Succeeded = 0,
    /**
     * The step failed with an error.
     */
    Failed = 1,
    /**
     * The step was skipped by control flow (e.g. it sat inside a <c>ConditionGroup</c>
     * branch that did not match).
     */
    Skipped = 2,
    /**
     * The step is a Human-in-the-Loop <c>Question</c> action that is currently waiting
     * for user input. Its row is updated in place with the answer and <c>Succeeded</c> once
     * the run resumes.
     */
    PausedForInput = 3,
    /**
     * The step was issued but has not reported back yet. Rows are written before the call goes out,
     * so a call that never returns still leaves a trace.
     */
    Running = 4,
}
